var originalUrl = window.location.pathname;

document.addEventListener('click', function(event) {
  var target = event.target;
  
  while (target !== null) {
    var isFilterItem = target.matches('.filter-item a');
    var isIconNavItem = target.matches('#IconNav ul li a');
    
    if (isFilterItem || isIconNavItem) {
      event.preventDefault();
      
      // Get the URL of the clicked link
      var url = target.getAttribute('href');
      
      // Get the text of the clicked link
      var filterName = target.textContent;
      
      // Check if the filter is already active
      if (target.parentNode.classList.contains('active')) {
        url = originalUrl;
        filterName = '';
      }
      
      const isMobile = document.documentElement.clientWidth <= 767;
      
      if (isMobile) {
        document.dispatchEvent(new CustomEvent('filter:hide'));
        const filterBtn = document.querySelector(".collection__filters__toggle");
        filterBtn.setAttribute('aria-expanded', 'false');
      }
      
      fetch(url)
        .then(response => response.text())
        .then(html => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var newContent = doc.querySelector('.collection__products').innerHTML;
          // Check if the URL contains "/search" before modifying the title
          if (!url.includes("/search")) {
            var newTitle = doc.querySelector('.collection__heading__text').innerHTML;
            
            // Prepend the filter name to the title and replace the title
            document.querySelector('.collection__heading__text').innerHTML = filterName + ' ' + newTitle;
          }
          
          // Replace the content
          document.querySelector('.collection__products').innerHTML = newContent;
          
          // Check if the RTE element exists before trying to replace its content
          var rteElement = doc.querySelector('.rte.standard__rte.collection__heading__text');
          if (rteElement) {
            // If the RTE element exists on the new page, replace the content.
            var newRTE = rteElement.innerHTML;
            document.querySelector('.rte.standard__rte.collection__heading__text').innerHTML = newRTE;
          } else {
            // If the RTE element does not exist on the new page, clear the previous content.
            var currentRTE = document.querySelector('.rte.standard__rte.collection__heading__text');
            if (currentRTE) {
              currentRTE.innerHTML = ''; // Clearing the inner HTML
            }
          }
          
          // Update the URL
          history.pushState(null, null, url);
          
          if (isMobile) {
            initFilterBtn();
          }
          
          // Remove the active class from all filters
          document.querySelectorAll('.filter-item').forEach(el => el.classList.remove('active'));
          
          // Remove the active class from all #IconNav list items
          document.querySelectorAll('#IconNav ul li').forEach(el => el.classList.remove('active'));
          
          // If the filter is not already active, add the active class
          if (url !== originalUrl) {
            target.parentNode.classList.add('active');
          }
        });
      
      break;
    }
    
    target = target.parentElement;
  }
});

function initFilterBtn() {
  const filterBtn = document.querySelector(".collection__filters__toggle");
  filterBtn.addEventListener("click", function() {
    const ariaExpanded = this.getAttribute('aria-expanded') === 'true';
    if (ariaExpanded) {
      document.dispatchEvent(new CustomEvent('filter:hide'));
      filterBtn.setAttribute('aria-expanded', 'false');
    } else {
      document.dispatchEvent(new CustomEvent('filter:show'));
      filterBtn.setAttribute('aria-expanded', 'true');
    }
  });
}
